import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import PropTypes from 'prop-types'

/**
 * The dead end an exempt account reaches while its exemption is switched off.
 *
 * There is no second factor to fall back on and nothing the person here can do — turning it back on
 * is an admin's doing, which is all the copy points them at. It deliberately does not say why: this
 * is unauthenticated ground, and whether an account is exempt from 2FA is not something to spell out
 * to whoever is holding the password.
 */
const TfaBypassDisabled = props => (
  <Paper elevation={3} component='div' className='tfa-bypass-disabled center-layout'>
    <Alert className='notice' severity='error'>
      <AlertTitle>We couldn't sign you in</AlertTitle>
      This account's sign-in settings need an administrator's attention before you can get in. Please
      get in touch with yours to have it put right.
    </Alert>
    <Button className='action' color='primary' onClick={props.onDismiss} variant='contained'>
      Back to sign in
    </Button>
  </Paper>
)

TfaBypassDisabled.propTypes = {
  onDismiss: PropTypes.func.isRequired
}

export default TfaBypassDisabled
